// extracted by mini-css-extract-plugin
export var saDefaultSection = "saDefaultSection-module--saDefaultSection--1kHFs";
export var saDefaultText = "saDefaultSection-module--saDefaultText--JzeSC";
export var saDefaultTitle = "saDefaultSection-module--saDefaultTitle--3nKe9";
export var saDefaultImage = "saDefaultSection-module--saDefaultImage--1YUlg";
export var saDefaultButton = "saDefaultSection-module--saDefaultButton--o-llc";